import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApiServiceService} from "../../../../Services/api-service.service";
import alertify from "alertifyjs";
import {CountryISO, SearchCountryField} from "ngx-intl-tel-input";
import {Observable} from "rxjs";
import {CurrencyPipe} from "@angular/common";
import {MDABillDto} from "../../search-mda-bill-history/search-mda-bill-history.component";
import {environment} from "../../../../../environments/environment";
import {PublicPaymentModalComponent} from "../../public-payment-modal/public-payment-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {AuthService} from "../../../../Services/auth.service";

@Component({
  selector: 'app-create-bills-public',
  templateUrl: './create-bills-public.component.html',
  styleUrls: ['./create-bills-public.component.css'],
  providers: [CurrencyPipe],
})
export class CreateBillsPublicComponent implements OnInit {
  form: FormGroup;
  asinForm: FormGroup;
  mdaForm: FormGroup;
  searching: boolean = false;
  previewItems: boolean = false;

  revenueCode:string;
  revenueName:string;
  mda: any;
  mda$: Observable<any[]>;
  hasPayerData: boolean = false;
  isSearching: boolean = false;
  mdaExtendedRevenue$: Observable<any[]>;
  mdaList$: Observable<any[]>;
  lottiePath = "assets/lottie/no-data.json";
  preferredCountries: string[] = ["ng", "us", "gb"];
  countryISO: CountryISO = CountryISO.Nigeria;
  protected readonly SearchCountryField = SearchCountryField;
  submitting: boolean;

  constructor(
      private apiService: ApiServiceService,
      private fb: FormBuilder,
      private currencyPipe: CurrencyPipe,
      private modalService: BsModalService,
      private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.getMdalist()

    this.mdaForm.get("mda").valueChanges.subscribe((v) => {
      if (v !== "" || v !== null || v !== undefined) {
        this.mdaList$?.subscribe((d: any[]) => {
          const result = d?.find((x: any) => x?.id == v);
          const name = result?.name;
          this.getExtendedRevenue(result.id);
          if (name !== null) {
            this.form.get("name").setValue(name);
          }
        });
      }
    });

    this.mdaForm.get("revenueId").valueChanges.subscribe((v) => {
      console.log(v);
      if (v !== "" || v !== null || v !== undefined) {
        this.mdaExtendedRevenue$?.subscribe((d: any[]) => {
          const result = d?.find((x: any) => x?.id == v);

          const description = result?.type;
          const amount = result?.amount;
          this.revenueCode = result.revenueCode;
          this.revenueName = result.name

          if (amount !== null ) {
            this.mdaForm.get("transactionAmount").setValue(amount);
            const value = parseFloat(this.mdaForm.get("transactionAmount").value);
            if (value) {
              this.mdaForm.get("transactionAmount")?.patchValue( this.currencyPipe.transform(value.toFixed(2), "NGN", "symbol-narrow"));
            }
            this.disableFormFieldsWithValues(this.mdaForm, [
              "transactionAmount",
            ]);
          }
          if (description !== null ) {
            this.mdaForm.get("serviceType").setValue(description);
            this.disableFormFieldsWithValues(this.mdaForm, [
              "serviceType",
            ]);
          }
          if (description !== null && amount !== null) {
            this.mdaForm.get("serviceType").setValue(description);
            this.mdaForm.get("transactionAmount").setValue(amount);
            this.disableFormFieldsWithValues(this.mdaForm, [
              "serviceType",
              "transactionAmount",
            ]);
          }
        });
      }
    });
  }
  enableFormFieldsWithValues(form: FormGroup, fieldsToDisable: string[]): void {
    fieldsToDisable.forEach((formControlName) => {
      const control = form?.get(formControlName);
      if (control.value) {
        control.enable();
      }
    });
  }
  disableFormFieldsWithValues(
      form: FormGroup,
      fieldsToDisable: string[],
  ): void {
    fieldsToDisable.forEach((formControlName) => {
      const control = form?.get(formControlName);
      if (control.value) {
        control.disable();
      }
    });
  }
  verifyTin(): void {
    this.searching = true;
    this.asinForm.markAllAsTouched();
    if (!this.asinForm.valid || this.asinForm?.get("asin")?.value === "") {
      this.searching = false;
      return;
    }
    this.apiService
        .post_g("/assessments/get/asin?asin=" + this.asinForm?.get("asin")?.value)
        .subscribe({
          next: (res: any) => {
            this.searching = false;
            if (res) {
              this.hasPayerData = true;
              this.form.patchValue({
                name: res?.displayname,
                asin: this.asinForm?.get("asin")?.value,
                phoneNumber: res?.phoneNumber,
                email: res?.email,
              });
              this.disableFormFieldsWithValues(this.form, ["name", "asin", "phoneNumber", "email"]);
            }
          },
          error: (err: any) => {
            console.log(err.message);
            this.searching = false;
            alertify.set("notifier", "position", "top-center");
            alertify.error("Invalid asin details");
            console.log(err);
          },
        });
  }

  getExtendedRevenue(id:number): void {
    const url = "/assessments/revenues/list/all?id="+id;
    this.mdaExtendedRevenue$ = this.apiService.get(url);
  }
  getMdalist(): void {
    const url = "/assessments/mdas/list/all";
    this.mdaList$ = this.apiService.get(url);
  }
  initializeForm(): void {
    this.asinForm = this.fb.group({
      asin: [""],
    });
    this.form = this.fb.group({
      name: [""],
      asin: ["", [Validators.required]],
      phoneNumber: [""],
      email: [""],
    });

    this.mdaForm = this.fb.group({
      mda: ["", [Validators.required]],
      revenueId: ["", [Validators.required]],
      paymentPeriod: ["", [Validators.required]],
      transactionAmount: ["", [Validators.required]],
      serviceType: ["", [Validators.required]],
      transactionDescription: [""],
    });
  }
  now(): Date {
    return new Date();
  }

  preview() {
    this.submitting = true
    this.disableFormFieldsWithValues(this.mdaForm, ["mda", "serviceType", "transactionAmount", "transactionDescription", "revenueId", "paymentPeriod"]);
    setTimeout(() => {
      this.previewItems = true;
      this.submitting = false;
    }, 1000);

  }

  downloadNotice(): void {

    alertify.set("notifier", "position", "top-right");
    alertify.success("Processing Request");
    this.submitting = true;
    const dto = {
      taxpayerDisplayName: this.form.get("name")?.value,
      taxpayerAsin: this.form.get("asin")?.value,
      taxpayerEmail: this.form.get("email")?.value,
      taxpayerPhoneNumber: this.form.get("phoneNumber")?.value?.e164Number,
      mdaId: this.mdaForm?.get("revenueId")?.value,
      paymentPeriod: this.mdaForm?.get("paymentPeriod")?.value,
      serviceType: this.mdaForm?.get("serviceType")?.value,
      transactionAmount: this.mdaForm?.get("transactionAmount")?.value,
      transactionDescription: this.mdaForm?.get("transactionDescription")?.value,
      revenueCode: this.revenueCode,
      revenueName: this.revenueName,
    };

    const url = "/assessments/print/mda/bills";
    this.apiService.post(url, dto).subscribe(
        (response: Blob) => {

          const blob = new Blob([response], { type: 'application/pdf' });

          // Create a Blob URL for the PDF content
          const blobUrl = window.URL.createObjectURL(blob);

          // Open PDF in a new tab
          // window.open(blobUrl, '_blank');

          const file = new Blob([response], { type: 'application/pdf' });

          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);

          // Optionally, trigger a download by creating an anchor element
          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.target = '_blank';
          downloadLink.download = dto.taxpayerAsin+'_demand_notice.pdf'; // File name for download

          // Uncomment this line to trigger the download automatically
          downloadLink.click();

          alertify.set("notifier", "position", "top-right");
          alertify.success("Download successful");
          this.submitting = false;
        },
        (error) => {
          console.log(error);
          this.submitting = false;
          alertify.set("notifier", "position", "top-right");
          alertify.error("Error performing this operation");
          // this.isEmpty = true;
        }
    );
  }

  payOnline() {
    const returnBackUrl = `${environment?.url}/payment/successful-payment`;
    this.submitting = true;
    let requestRemitaRRR = {
      returnBackUrl: returnBackUrl,
      totalAmount: this.mdaForm?.get("transactionAmount")?.value,
      fullName: this.form.get("name")?.value,
      customerId: this.form.get("asin")?.value,
      revenueName: this.revenueName,
      revenueId: this.revenueCode,
      email: this.form.get("email")?.value,
      taxGroup: "INDIVIDUAL",
      phoneNumber: this.form.get("phoneNumber")?.value?.e164Number,
      feeDescription: this.revenueName,
      entityName: this.revenueName,
      entityType: "MDA",
      entityGroup: this.mdaForm?.get("serviceType")?.value,
      mdaRecordId: this.mdaForm?.get("mda")?.value,
    };

    let bsModalRef = this.modalService.show(PublicPaymentModalComponent, {
      initialState: {
        details: requestRemitaRRR,
      },
      backdrop: true,
      class: "modal-md modal-dialog-centered",
      ignoreBackdropClick: true,
    });
    bsModalRef?.content?.onConfirmClicked.subscribe((v) => {
      bsModalRef.hide();
    });
  }

  payment() {

    alertify.set("notifier", "position", "top-center");
    alertify.success("Processing Request");
    const dto = {
      taxpayerDisplayName: this.form.get("name")?.value,
      taxpayerAsin: this.form.get("asin")?.value,
      taxpayerEmail: this.form.get("email")?.value,
      taxpayerPhoneNumber: this.form.get("phoneNumber")?.value?.e164Number,
      mdaId: this.mdaForm?.get("revenueId")?.value,
      paymentPeriod: this.mdaForm?.get("paymentPeriod")?.value,
      serviceType: this.mdaForm?.get("serviceType")?.value,
      transactionAmount: this.mdaForm?.get("transactionAmount")?.value,
      transactionDescription: this.mdaForm?.get("transactionDescription")?.value,
      revenueCode: this.revenueCode,
      revenueName: this.revenueName,
    };

    const url = "/assessments/generate-mda-bill-public";
    this.apiService.post(url, dto).subscribe(
        (response) => {
         this.completeTransfer();
          this.payOnline();
          setTimeout(() => {
          }, 3000);
        },
        (error) => {
          this.submitting = false;
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        },
    );
  }

  completeTransfer(){
    this.submitting = false;
    this.hasPayerData = false;
    this.previewItems = false;
    this.form.reset()
    this.mdaForm.reset();
    this.enableFormFieldsWithValues(this.mdaForm, ["mda", "serviceType", "transactionAmount", "transactionDescription", "revenueId", "paymentPeriod"])
  }

  hasAccess(permissions:string[]){
    return this.authService.hasAnyPermission(permissions)
  }
}
